import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainLayout from './layouts/MainLayout/MainLayout';
import AuthLayout from './layouts/AuthLayout/AuthLayout';
import PublicRoutes from './routes/publicRoute';
import PrivateRoutes from './routes/privateRoute'; // Change to PrivateRoutes (plural)
import './App.css';
import { LOGIN_SUCCESS } from './store/constant/user';

function App() {
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.userDetails);
    const {token, userResponse} = userInfo || {}
    const [isAuth, setAuth] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userDetails = localStorage.getItem('userInfo');
        
        if (token && userDetails) {
            try {
                const parsedUserDetails = JSON.parse(userDetails);
                const userObject = {
                    token: token,
                    userResponse: parsedUserDetails
                }
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: userObject,
                });
                setAuth(true);
            } catch (error) {
                console.error('Error parsing user details:', error);
                setAuth(false);
            }
        } else {
            setAuth(false);
        }
        setIsLoading(false);
    }, [dispatch]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <React.Fragment>
            <Router>
                {isAuth ? (
                    <MainLayout>
                        <PrivateRoutes auth={isAuth} />
                    </MainLayout>
                ) : (
                    <AuthLayout>
                        <PublicRoutes auth={isAuth} />
                    </AuthLayout>
                )}
            </Router>
        </React.Fragment>
    );
}

export default App;
